import React from "react";
import { Row } from "reactstrap";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { PaginationComponentProps } from "./pagination-component-props";
import "./pagination-component.scss";
import { PaginationItem, useMediaQuery } from "@mui/material";
import {
  KeyboardDoubleArrowLeftRounded,
  KeyboardDoubleArrowRightRounded,
} from "@mui/icons-material";

const PaginationComponent: React.FC<PaginationComponentProps> = ({
  totalRecords,
  pageSize,
  currentPage,
  onPageChange,
}) => {
  const pageCount = Math.ceil(totalRecords / pageSize) || 1;
  const isMobile = useMediaQuery("(max-width:1100px)");

  return (
    <Row className="pagination-component">
      <Stack spacing={2}>
        <Pagination
          count={pageCount}
          page={currentPage}
          onChange={onPageChange}
          variant="outlined"
          shape="rounded"
          boundaryCount={isMobile ? 1 : 1}
          siblingCount={isMobile ? 0 : 2}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              slots={{
                previous: KeyboardDoubleArrowLeftRounded,
                next: KeyboardDoubleArrowRightRounded,
              }}
            />
          )}
        />
      </Stack>
    </Row>
  );
};

export default PaginationComponent;
